import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';

import './ApprovalStatus.scss';

class ApprovalStatus extends React.Component {
    constructor(props) {
        super(props);
        this.handleApprove = this.handleApprove.bind(this);
        this.handleReject = this.handleReject.bind(this);
    }

    handleApprove(e) {
        const {approveRequest, requestId, currentUser, permissions} = this.props;
        e.preventDefault();
        console.log('approve');
        // const advocateOrResource = !!permissions.find((perm) => {
        //     return perm = currentUser.userId;
        // });
        approveRequest(requestId);
    }

    handleReject(e) {
        const {rejectRequest, requestId} = this.props;
        e.preventDefault();
        console.log('reject');
        rejectRequest(requestId);
    }

    render() {
        const { requests, requestId, isAdmin } = this.props;
        const request = requests.find((r) => {
            return r.requestInfo.requestId === requestId;
        });

        const renderApproveButton = () => {
            if (isAdmin) {
                return (
                    <div>
                        <button onClick={this.handleApprove.bind(this)}>Approve</button>
                        <button onClick={this.handleReject.bind(this)}>Reject</button>
                    </div>
                );
            }
        }

        return (
            <div className="approval-container">
                <div className="advocate-approval">
                    Advocate Status: {request.requestInfo.advocateApproval}
                </div>
                <div className="resources-approval">
                    Resource Status: {request.requestInfo.resourceApproval}
                </div>
                {renderApproveButton()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users,
        currentUser: state.currentUser,
        requests: state.requests,
        permissions: state.permissions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalStatus);



/** WEBPACK FOOTER **
 ** ./src/components/ApprovalStatus/ApprovalStatus.js
 **/